import { render, staticRenderFns } from "./zcurrency.vue?vue&type=template&id=833703c0&scoped=true"
import script from "./zcurrency.vue?vue&type=script&lang=js"
export * from "./zcurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833703c0",
  null
  
)

export default component.exports